import { Reveal, SectionLabel } from "./Reveal";

const PHOTOS = [
    {
        src: "/photos/trabalho-sofa-colagem.jpg",
        alt: "Registro real de higienização de sofá pela Brandão Morais Higienização",
        real: true,
    },
    {
        src: "/photos/depois-colchao-2.jpg",
        alt: "Colchão após higienização profissional — trabalho real da Brandão Morais",
        real: true,
    },
    {
        src: "/photos/sofa-branco-about.jpg",
        alt: "Sofá branco após higienização profissional — trabalho real da Brandão Morais",
        real: true,
    },
    {
        src: "/photos/card-antes-depois-branco.jpg",
        alt: "Antes e depois real de sofá branco higienizado pela Brandão Morais",
        real: true,
    },
    {
        src: "/photos/sofa-branco-detalhe.jpg",
        alt: "Detalhe de sofá após higienização profissional — trabalho real",
        real: true,
    },
    {
        src: "/photos/depois-sofa-retratil.jpg",
        alt: "Sofá retrátil após higienização profissional — trabalho real da Brandão Morais",
        real: true,
    },
];

export const Gallery = () => (
    <section
        id="galeria"
        data-testid="gallery-section"
        className="bg-navy noise-bg py-24 lg:py-32"
    >
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
                <Reveal>
                    <SectionLabel light>Galeria</SectionLabel>
                    <h2 className="mt-5 font-display font-bold text-white tracking-tight text-4xl sm:text-5xl leading-[1.1] max-w-xl">
                        Nosso trabalho em <span className="text-brand">imagens</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.15}>
                    <p
                        data-testid="gallery-placeholder-note"
                        className="text-white/40 text-sm max-w-md leading-relaxed"
                    >
                        Registros reais dos nossos trabalhos e espaço preparado para novas fotos
                        dos serviços realizados.
                    </p>
                </Reveal>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 auto-rows-[180px] sm:auto-rows-[220px]">
                {PHOTOS.map((photo, i) => (
                    <Reveal
                        key={i}
                        delay={(i % 4) * 0.08}
                        className={i === 0 || i === 3 ? "col-span-2 row-span-2" : ""}
                    >
                        <div
                            data-testid={`gallery-item-${i}`}
                            className="group relative w-full h-full rounded-2xl overflow-hidden border border-white/10 hover:border-brand transition-colors duration-300"
                        >
                            <img
                                src={photo.src}
                                alt={photo.alt}
                                loading="lazy"
                                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-navy/0 group-hover:bg-navy/30 transition-colors duration-500" />
                            {photo.real && (
                                <span className="absolute top-3 left-3 bg-brand text-white text-[10px] font-bold tracking-[0.15em] uppercase px-3 py-1.5 rounded-full">
                                    Trabalho real
                                </span>
                            )}
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
